import { LoadingButton } from '@mui/lab'
import { TextField, Tooltip } from '@mui/material'
import {
    ColumnsPanelTrigger,
    FilterPanelTrigger,
    GridApi,
    GridFilterListIcon,
    GridToolbarProps,
    GridViewColumnIcon,
    QuickFilter,
    QuickFilterControl,
    Toolbar,
    ToolbarButton,
    ToolbarPropsOverrides,
    useGridApiContext,
} from '@mui/x-data-grid-pro'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

type CustomToolbarProps = GridToolbarProps & ToolbarPropsOverrides

export default function CustomToolbar({
    exportAllRows,
    exporting,
    exportFilename,
    exportAs,
    quickFilterProps,
}: CustomToolbarProps) {
    const apiRef = useGridApiContext() as React.MutableRefObject<GridApi>

    return (
        <Toolbar>
            <QuickFilter
                style={{
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    marginRight: 'auto',
                }}
                parser={quickFilterProps?.quickFilterParser}
                formatter={quickFilterProps?.quickFilterFormatter}
                debounceMs={quickFilterProps?.debounceMs}
            >
                <QuickFilterControl
                    render={({ ref, ...controlProps }) => (
                        <TextField
                            inputRef={ref}
                            label="Search..."
                            variant="standard"
                            size="small"
                            {...controlProps}
                        />
                    )}
                />
            </QuickFilter>
            <Tooltip title="Columns">
                <ColumnsPanelTrigger render={<ToolbarButton />}>
                    <GridViewColumnIcon fontSize="small" />
                </ColumnsPanelTrigger>
            </Tooltip>
            <Tooltip title="Filter">
                <FilterPanelTrigger render={<ToolbarButton />}>
                    <GridFilterListIcon fontSize="small" />
                </FilterPanelTrigger>
            </Tooltip>
            <ToolbarButton
                render={
                    <LoadingButton
                        variant="text"
                        loading={exporting}
                        disabled={!exportAllRows}
                        onClick={() =>
                            exportAllRows!(
                                apiRef,
                                exportAs === 'xlsx'
                                    ? undefined
                                    : apiRef.current.exportDataAsCsv,
                                exportFilename
                            )
                        }
                        startIcon={<FileDownloadIcon />}
                        sx={{ padding: '4px 5px' }}
                    >
                        EXPORT
                    </LoadingButton>
                }
            />
        </Toolbar>
    )
}
